// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1gNKu","alertIcon":"ConfirmModal_alertIcon__2rxTX"};